import { useNavigate  } from "react-router-dom";

function HomeButton() {
  let navigate = useNavigate();

  function handleClick() {
    navigate("/");
  }

  return (
    <div style={{position:'fixed' ,top: '0',right:'0',zIndex: 1000 }} className='px-8 py-2'>
        <button type="button" className="bg-black border-2 border-black rounded-full" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" style={{color: 'white'}} fill="currentColor" className="drop-shadow-sm bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
          </svg>
        </button>
    </div>
  );
}
export default HomeButton;